import { z } from "zod/v4";

import { isArrayOf } from "utils/typeGuards";

import { createZodStringOption } from "./validation.utils";

// Standard Date Ranges with optional start and end properties
export const DateRangeSchema = z.object({
  after: z.string().optional(),
  before: z.string().optional(),
});
export type DateRange = z.infer<typeof DateRangeSchema>;

export const isDateRangeObject = (value: unknown): value is DateRange => {
  return DateRangeSchema.safeParse(value).success;
};

export const isDateRangeArray = (arr: unknown[]): arr is DateRange[] =>
  isArrayOf(arr, isDateRangeObject);

// Dynamic Date ranges with a field property
export const DynamicDateRangeSchema = DateRangeSchema.extend({
  field: createZodStringOption().or(z.string()),
});
export type DynamicDateRange = z.infer<typeof DynamicDateRangeSchema>;

export const isDynamicDateRangeObject = (
  value: unknown,
): value is DynamicDateRange => {
  return DynamicDateRangeSchema.safeParse(value).success;
};

export const isDynamicDateRangeArray = (
  arr: unknown[],
): arr is DynamicDateRange[] => isArrayOf(arr, isDynamicDateRangeObject);
